<nav>
  <div class="logo">
    <!-- <img alt="Logo" src="../../../../assets/image/medo-logo.png" /> -->
    <img alt="Logo" src="../../../../assets/image/appsrihno-logo.svg" />
  </div>

  <div class="navigations">
    <!-- <div class="navigation-item">
      <div class="menu-option" routerLinkActive="active-sub-menu" [routerLink]="['../dashboard']">
        <span class="material-icons">
          dashboard
        </span>
        <span class="text">
          Dashboard
        </span>
        <span *ngIf="expandedMenu !== 'Dashboard'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Dashboard'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Dashboard'" class="navigation-sub-menu">
        <span class="navigation-sub-menu-item" [routerLink]="['../dashboard']"   routerLinkActive="active-sub-menu" >Partner Concentrations</span>
        <span class="navigation-sub-menu-item" [routerLink]="['../dashboard']"   routerLinkActive="active-sub-menu" >Growth Trends</span>
      </div>
    </div> -->
    <div class="navigation-item" appAcl permission="diagnostics||doctors||vles||patients">
      <div (click)="toggleMenuItem('User')" class="menu-option" routerLinkActive="active-menu">
        <span class="material-icons">
          people
        </span>
        <span class="text">
          Users
        </span>
        <span *ngIf="expandedMenu !== 'User'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'User'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'User'" class="navigation-sub-menu">
        <span appAcl permission="patients||services" [routerLink]="['/user/customer']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Customers</span>
        <span *ngIf="role === 'ZONAL BUSINESS MANAGER' || role === 'REGIONAL BUSINESS MANAGER' || role==='ADMIN'" appAcl
          permission="vles" [routerLink]="['/user/vle']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">MedoMITR</span>
        <span appAcl permission="doctors" [routerLink]="['/user/doctor']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Doctors</span>
        <span appAcl permission="diagnostics" [routerLink]="['/user/diagnostics']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Diagnostics</span>
        <!--                <span  [routerLink]="['../user/hospitals']" class="navigation-sub-menu-item"-->
        <!--                      routerLinkActive="active-sub-menu">Hospitals</span>-->
        <!-- TO DO REMOVE COMMENT -->
        <span appAcl permission="pharmacies" [routerLink]="['/user/pharmacies']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Pharmacies</span>
        <!-- <span [routerLink]="['../user/blood-banks']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Blood Banks</span> -->
        <!-- <span [routerLink]="['../user/ambulances']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Ambulances</span> -->
      </div>
    </div>
    <div class="navigation-item" appAcl permission="appointment||refunds">
      <div (click)="toggleMenuItem('Booking')" class="menu-option">
        <span class="material-icons">
          book_online
        </span>
        <span class="text">
          Bookings
        </span>
        <span *ngIf="expandedMenu !== 'Booking'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Booking'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Booking'" class="navigation-sub-menu">
        <span appAcl permission="appointment" [routerLink]="['/booking/doctor-appointments']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Doctor Appointments</span>
        <span appAcl permission="appointment" [routerLink]="['/booking/diagnostics-appointment']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu"> Diagnostics Appointment</span>
        <span appAcl permission="appointment" [routerLink]="['/booking/pharmacy-transactions']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Pharmacy Transactions</span>
        <span appAcl permission="refunds" [routerLink]="['/booking/refund-request']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Refund Requests</span>
        <span appAcl permission="appointment" [routerLink]="['/booking/overdue']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Pending Closure</span>
      </div>
    </div>
    <div class="navigation-item" appAcl permission="services||static-reason">
      <div (click)="toggleMenuItem('Inventory')" class="menu-option">
        <span class="material-icons">
          inventory
        </span>
        <span class="text">
          Inventory
        </span>
        <span *ngIf="expandedMenu !== 'Inventory'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Inventory'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Inventory'" class="navigation-sub-menu">
        <span appAcl permission="services" [routerLink]="['/inventory/ailments']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Ailments</span>
        <span appAcl permission="services" [routerLink]="['/inventory/doctor-specialization']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Doctor Specialization</span>
        <span appAcl permission="services" [routerLink]="['/inventory/diagnostic-tests']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Diagnostic Tests</span>
        <span appAcl permission="services" [routerLink]="['/inventory/diagnostic-test-packages']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Diagnostic Packages</span>
        <!-- <span appAcl permission="services" [routerLink]="['../inventory/pharmacy-services']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Pharmacy Services</span> -->
        <!-- TODO -->
        <!-- <span [routerLink]="['../inventory/hospitalizations']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Hospitalizations Packages</span> -->
        <span appAcl permission="static-reason" [routerLink]="['/inventory/cancellation']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Static Reasons for C&F</span>
      </div>
    </div>
    <div class="navigation-item" appAcl permission="contract"
      *ngIf="role!=='ZONAL BUSINESS MANAGER' || 'REGIONAL BUSINESS MANAGER'">
      <div (click)="toggleMenuItem('Contracts')" class="menu-option">
        <!-- <div routerLink="../contracts/active" routerLinkActive="active-sub-menu" class="menu-option"> -->
        <span class="material-icons">
          history_edu
        </span>
        <span class="text">
          Contracts
        </span>
        <span *ngIf="expandedMenu !== 'Contracts'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Contracts'" class="material-icons dropdown-icon"> keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Contracts'" class="navigation-sub-menu">
        <span [routerLink]="['/contracts/active']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Active Contracts</span>
        <span [routerLink]="['/contracts/contract-update-request']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Contract Update Request</span>
        <span [routerLink]="['/contracts/reject-contract']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu"> Rejected Contracts</span>
        <span [routerLink]="['/contracts/inactive-contract']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Inactive Contracts</span>
        <span [routerLink]="['/contracts/contract-below-guard']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Contract Below Guard Rail</span>
        <span [routerLink]="['/contracts/close-contract']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Closed Contracts</span>
      </div>
    </div>

    <div class="navigation-item" appAcl permission="transactions||settlements" *ngIf="role==='ADMIN'">
      <div (click)="toggleMenuItem('Accounting')" class="menu-option">
        <span class="material-icons">
          account_balance
        </span>
        <span class="text">
          Accounting
        </span>
        <span *ngIf="expandedMenu !== 'Accounting'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Accounting'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Accounting'" class="navigation-sub-menu">
        <span appAcl permission="transactions" [routerLink]="['/accounting/all-transactions']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">All transactions</span>
        <span appAcl permission="transactions" [routerLink]="['/accounting/failed-transactions']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Failed Transactions</span>
        <!-- <span appAcl permission="transactions" [routerLink]="['../accounting/mismatched-transaction']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Mismatched Transaction</span> -->
        <!--          <span appAcl permission="settlements" [routerLink]="['../accounting/payout']" class="navigation-sub-menu-item"-->
        <!--            routerLinkActive="active-sub-menu">Payout</span>-->
      </div>
    </div>

    <!-- CMS Tab -->
    <div class="navigation-item" appAcl permission="cms" *ngIf="role==='ADMIN'">
      <div (click)="toggleMenuItem('Cms')" class="menu-option">
        <span class="material-icons">
          color_lens
        </span>
        <span class="text">
          CMS
        </span>
        <span *ngIf="expandedMenu !== 'Cms'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Cms'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Cms'" class="navigation-sub-menu">
        <span appAcl permission="cms" [routerLink]="['/cms/contact']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Contact Details</span>
        <span appAcl permission="cms" [routerLink]="['/cms/privacy-policy']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Privacy Policy</span>
        <span appAcl permission="cms" [routerLink]="['/cms/terms-conditions']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Terms and Conditions</span>
        <!-- <span class="navigation-sub-menu-item" [routerLink]="['../cms/cancel-policy']"   routerLinkActive="active-sub-menu" >Cancellation Policy</span> -->
        <span appAcl permission="cms" [routerLink]="['/cms/about-us']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">About us</span>
        <span appAcl permission="cms" [routerLink]="['/cms/about-team']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">About Team</span>
        <span appAcl permission="cms" [routerLink]="['/cms/career']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Careers</span>
        <!-- <span [routerLink]="['../cms/site-setting']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Site Setting</span> -->
        <span appAcl permission="cms" [routerLink]="['/cms/banner']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Banners</span>
        <span appAcl permission="cms" [routerLink]="['/cms/website-banner']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Website-Banners</span>
        <span appAcl permission="cms" [routerLink]="['/cms/faq']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">FAQ</span>
      </div>
    </div>

    <!-- Subscription Tab -->
    <div class="navigation-item" appAcl permission="subscriptions" *ngIf="role==='ADMIN'">
      <div (click)="toggleMenuItem('Subscription')" class="menu-option">
        <span class="material-icons">
          card_membership
        </span>
        <span class="text">
          Subscription
        </span>
        <span *ngIf="expandedMenu !== 'Subscription'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Subscription'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Subscription'" class="navigation-sub-menu">
        <span appAcl permission="subscriptions" [routerLink]="['/subscription/subscription-plans']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Subscription Plans</span>
        <span appAcl permission="subscriptions" [routerLink]="['/subscription/subscriptions']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Subscriptions</span>
      </div>
    </div>

    <!-- Ratings Tab -->
    <div class="navigation-item" appAcl permission="ratings">
      <div (click)="toggleMenuItem('Rating')" class="menu-option">
        <span class="material-icons">
          grade
        </span>
        <span class="text">
          Rating and Reviews
        </span>
        <span *ngIf="expandedMenu !== 'Rating'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Rating'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>

      </div>
      <div *ngIf="expandedMenu === 'Rating'" class="navigation-sub-menu">
        <span appAcl permission="ratings" [routerLink]="['/rating/operational-review']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Operational Reviews</span>
        <span appAcl permission="ratings" [routerLink]="['/rating/medoplus-review']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Medoplus Reviews</span>
      </div>
    </div>
    <div class="navigation-item" appAcl permission="leads">
      <div (click)="toggleMenuItem('Leads')" class="menu-option">
        <span class="material-icons">
          leaderboard
        </span>
        <span class="text">
          Leads
        </span>
        <span *ngIf="expandedMenu !== 'Leads'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'Leads'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'Leads'" class="navigation-sub-menu">
        <span appAcl permission="vles" [routerLink]="['/leads/vle']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Medo
          MITR</span>
        <span appAcl permission="doctors" [routerLink]="['/leads/doctor']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Doctor</span>
        <span appAcl permission="diagnostics" [routerLink]="['/leads/diagnostics']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Diagnostics</span>
        <span appAcl permission="pharmacies" [routerLink]="['/leads/pharmacies']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Pharmacies</span>
        <!-- TODO REMOVE COMMENT -->
        <!-- <span [routerLink]="['../leads/hospitals']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Hospitals</span>
          <span [routerLink]="['../leads/ambulances']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Ambulances</span>
          <span [routerLink]="['../leads/blood-bank']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Blood Banks</span>
          <span [routerLink]="['../leads/contact']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Contact leads</span> -->
        <span [routerLink]="['/leads/booking-leads']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Patient Leads</span>
        <span *ngIf="role==='ADMIN'" [routerLink]="['/leads/service-leads']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Service Leads</span>
        <span appAcl permission="hospitals" [routerLink]="['/leads/callback-leads']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Hospitalization Leads</span>
        <!-- <span [routerLink]="['../leads/facility-leads']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Facility Leads</span> -->
      </div>
    </div>
    <!-- TODO REMOVE COMMENT -->
    <!-- <div class="navigation-item">
        <div class="menu-option " (click)="toggleMenuItem('Reports')">
          <span class="material-icons">
            description
          </span>
          <span class="text">
            Reports
          </span>
          <span *ngIf="expandedMenu !== 'Reports'" class="material-icons dropdown-icon">
            keyboard_arrow_right
          </span>
          <span *ngIf="expandedMenu === 'Reports'" class="material-icons dropdown-icon">
            keyboard_arrow_down
          </span>
        </div>
        <div *ngIf="expandedMenu === 'Reports'" class="navigation-sub-menu">
          <span [routerLink]="['../reports/medical-needs']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Medical Needs</span>
          <span [routerLink]="['../reports/partners']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Partners</span>
          <span [routerLink]="['../reports/ailments']" class="navigation-sub-menu-item"
            routerLinkActive="active-sub-menu">Ailments</span>
        </div>
      </div> -->
    <!-- <div class="navigation-item">
        <div class="menu-option" routerLinkActive="active-sub-menu" (click)="toggleMenuItem('Feeds')">
          <span class="material-icons">
            feedback
          </span>
          <span class="text">
            Feeds
          </span>
          <span *ngIf="expandedMenu !== 'Feeds'" class="material-icons dropdown-icon">
            keyboard_arrow_right
          </span>
          <span *ngIf="expandedMenu === 'Feeds'" class="material-icons dropdown-icon">
            keyboard_arrow_down
          </span>
        </div>
        <div class="navigation-sub-menu" *ngIf="expandedMenu === 'Feeds'">
        <span class="navigation-sub-menu-item"  >Feeds</span>
      </div>
      </div> -->

    <div class="navigation-item" appAcl permission="roles||admin||sales-executives||enrol-executives">
      <div (click)="toggleMenuItem('ACL')" class="menu-option">
        <span class="material-icons">
          manage_accounts
        </span>
        <span class="text">
          Access Control
        </span>
        <span *ngIf="expandedMenu !== 'ACL'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'ACL'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'ACL'" class="navigation-sub-menu">
        <span *ngIf="role==='ADMIN'" appAcl permission="roles" [routerLink]="['/acl/roles']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">All
          Roles</span>
        <span *ngIf="role==='REGIONAL BUSINESS MANAGER' || role==='REGIONAL HEALTH MANAGER' || role==='ADMIN'" appAcl
          permission="roles" [routerLink]="['/acl/admin-users']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Admin Users</span>
        <span *ngIf="role==='ZONAL BUSINESS MANAGER' || role==='REGIONAL BUSINESS MANAGER' || role==='ADMIN'" appAcl
          permission="sales-executives" [routerLink]="['/acl/sales']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Sales
          Ex</span>
        <span *ngIf="role==='ZONAL HEALTH MANAGER' || role==='REGIONAL HEALTH MANAGER' || role==='ADMIN'" appAcl
          permission="enroll-executives" [routerLink]="['/acl/enrollment']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Enrollment Ex</span>

        <!-- zhm , zbm roles will added after that below two span will be edited with permisiions *Manish  -->

        <!-- <span  [routerLink]="['../acl/zhm']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">ZHM</span>
        <span  [routerLink]="['../acl/zbm']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">ZBM</span> -->
      </div>
    </div>
    <div class="navigation-item" appAcl permission="slabs||taxes" *ngIf="role==='ADMIN'">
      <div (click)="toggleMenuItem('configurations')" class="menu-option">
        <span class="material-icons">
          <span class="material-icons">
            settings
          </span>
        </span>
        <span class="text">
          Configurations
        </span>
        <span *ngIf="expandedMenu !== 'configurations'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'configurations'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'configurations'" class="navigation-sub-menu">
        <span appAcl permission="slabs" [routerLink]="['/configuration/revenue-share']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Revenue Share</span>
        <span appAcl permission="slabs" [routerLink]="['/configuration/token-amount']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Token Amount</span>
        <span appAcl permission="taxes" [routerLink]="['/configuration/other-configuration']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Other configuration</span>
        <span appAcl permission="taxes" [routerLink]="['/configuration/mitr-registration-fee']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">MITR Registration Fee</span>
        <span [routerLink]="['/configuration/additional-configuration/pregnancy-config']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Standards and Timelines</span>
        <span [routerLink]="['/configuration/iframe']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">BI Screens Configurations</span>
        <span appAcl permission="slabs" [routerLink]="['/configuration/referral-code']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Referral Code</span>
        <span appAcl permission="slabs" [routerLink]="['/configuration/body-vitals']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Body Vitals</span>
        <!--            <span [routerLink]="['../configuration/notifications']" class="navigation-sub-menu-item"-->
        <!--              routerLinkActive="active-sub-menu">Notifications</span>-->

        <span appAcl permission="slabs" [routerLink]="['/configuration/video-consultation']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Video Consultation</span>
        <span appAcl permission="slabs" [routerLink]="['/configuration/email-configuration']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Email Configuration</span>
        <span appAcl permission="camp" [routerLink]="['/configuration/camp-configuration']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Camp Configuration</span>
      </div>
    </div>

    <!-- This will be edited in the future when full permissions will be made according to new component *Manish   -->
    <div class="navigation-item" *ngIf="role==='ADMIN'">
      <div (click)="toggleMenuItem('territory')" class="menu-option">
        <span class="material-icons">
          <span class="material-icons">
            holiday_village
          </span>
        </span>
        <span class="text">
          Territory
        </span>
        <span *ngIf="expandedMenu !== 'territory'" class="material-icons dropdown-icon">
          keyboard_arrow_right
        </span>
        <span *ngIf="expandedMenu === 'territory'" class="material-icons dropdown-icon">
          keyboard_arrow_down
        </span>
      </div>
      <div *ngIf="expandedMenu === 'territory'" class="navigation-sub-menu">
        <span [routerLink]="['/territory/list-states']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">States</span>
        <span [routerLink]="['/territory/list-districts']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Districts</span>
        <span [routerLink]="['/territory/list-tehsils']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Tehsils</span>
        <span [routerLink]="['/territory/list-blocks']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Blocks</span>
        <span [routerLink]="['/territory/list-villages']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Village</span>
        <span [routerLink]="['/territory/pin-code']" class="navigation-sub-menu-item"
          routerLinkActive="active-sub-menu">Pin Code</span>
        <!-- <span  [routerLink]="['../territory/add-village']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Add Village</span>
        <span  [routerLink]="['../territory/edit-village']"
          class="navigation-sub-menu-item" routerLinkActive="active-sub-menu">Edit Village</span> -->
      </div>
    </div>
  </div>
</nav>